import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import Footer from './Footer';
import * as ROUTES from '../../routes/';

const FooterContainer = () => {
  const clientSections = [
    {
      name: 'Encontrar abogado',
      link: 'scroll',
      to: 'searchLawyer',
      duration: 500,
    },
    {
      name: 'Cómo funciona',
      link: 'scroll',
      to: 'funciona',
      duration: 1500,
    },
    {
      name: 'Abogados plus',
      link: 'scroll',
      to: 'abogados-top',
      duration: 1000,
    },
    /* {
      name: 'Blog',
      link: 'router',
      to: '/articulos',
    }, */
    {
      name: 'Despachos plus',
      link: 'scroll',
      to: 'despachos-top',
      duration: 1500,
    },
    /* {
      name: 'Comunidad',
      link: 'router',
      to: '/comunidad',
    }, */
    // {
    //   name: 'Beneficios',
    //   link: 'scroll',
    //   to: 'benefits',
    //   duration: 500,
    // },
  ];

  const lawyerSections = [
    // {
    //   name: 'Quiénes somos',
    //   link: 'scroll',
    //   to: 'about',
    //   duration: 500,
    // },
    // {
    //   name: 'Beneficios',
    //   link: 'scroll',
    //   to: 'benefits',
    //   duration: 1000,
    // },
    // {
    //   name: 'Cómo funciona',
    //   link: 'scroll',
    //   to: 'how',
    //   duration: 1500,
    // },
    // {
    //   name: 'Comunidad',
    //   link: 'scroll',
    //   to: 'lawyers_com',
    //   duration: 1500,
    // },
    {
      name: 'Encontrar abogado',
      link: 'scroll',
      to: 'searchLawyer',
      duration: 500,
    },
    {
      name: 'Cómo funciona',
      link: 'scroll',
      to: 'funciona',
      duration: 1500,
    },
    {
      name: 'Abogados plus',
      link: 'scroll',
      to: 'abogados-top',
      duration: 1000,
    },
   /*  {
      name: 'Blog',
      link: 'router',
      to: '/articulos',
    }, */
    {
      name: 'Despachos plus',
      link: 'scroll',
      to: 'despachos-top',
      duration: 1500,
    },
   /*  {
      name: 'Comunidad',
      link: 'router',
      to: '/comunidad',
    }, */
  ];
  const landingLawyers = useRouteMatch(ROUTES.LANDING_PAGE);
  const landingClient = useRouteMatch(ROUTES.LANDING_PAGE_CLIENT);

  if (landingClient && landingClient.isExact) {
    return <Footer sections={clientSections} />;
  } else if (landingLawyers && landingLawyers.isExact) {
    return <Footer sections={lawyerSections} />;
  } else {
    return <Footer sections={null} />;
  }
};

export default FooterContainer;
